export const trash = {
  "v": "5.9.6",
  "fr": 60,
  "ip": 0,
  "op": 120,
  "w": 750,
  "h": 750,
  "nm": "Comp 1",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Group 2",
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 100,
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [
                  0.2
                ],
                "y": [
                  1
                ]
              },
              "o": {
                "x": [
                  0.8
                ],
                "y": [
                  0
                ]
              },
              "t": 0,
              "s": [
                0
              ]
            },
            {
              "i": {
                "x": [
                  0.2
                ],
                "y": [
                  1
                ]
              },
              "o": {
                "x": [
                  0.8
                ],
                "y": [
                  0
                ]
              },
              "t": 20.02,
              "s": [
                13
              ]
            },
            {
              "t": 40.041015625,
              "s": [
                0
              ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.2,
                "y": 1
              },
              "o": {
                "x": 0.8,
                "y": 0
              },
              "t": 0,
              "s": [
                579,
                255.473,
                0
              ],
              "to": null,
              "ti": null
            },
            {
              "i": {
                "x": 0.2,
                "y": 1
              },
              "o": {
                "x": 0.8,
                "y": 0
              },
              "t": 20.02,
              "s": [
                579,
                196.473,
                0
              ],
              "to": null,
              "ti": null
            },
            {
              "t": 40.041015625,
              "s": [
                579,
                255.473,
                0
              ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [
            723.971,
            371.68,
            0
          ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [
            100,
            100,
            100
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          97.281,
                          27.438
                        ],
                        [
                          -97.281,
                          27.438
                        ],
                        [
                          -97.281,
                          27.438
                        ],
                        [
                          -72.712,
                          -27.438
                        ],
                        [
                          42.405,
                          -27.438
                        ],
                        [
                          97.281,
                          -2.8689999999999998
                        ]
                      ],
                      "o": [
                        [
                          97.281,
                          27.438
                        ],
                        [
                          -97.281,
                          27.438
                        ],
                        [
                          -97.281,
                          -2.8689999999999998
                        ],
                        [
                          -42.405,
                          -27.438
                        ],
                        [
                          72.712,
                          -27.438
                        ],
                        [
                          97.281,
                          27.438
                        ]
                      ],
                      "v": [
                        [
                          97.281,
                          27.438
                        ],
                        [
                          -97.281,
                          27.438
                        ],
                        [
                          -97.281,
                          27.438
                        ],
                        [
                          -42.405,
                          -27.438
                        ],
                        [
                          42.405,
                          -27.438
                        ],
                        [
                          97.281,
                          27.438
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [
                      0,
                      0,
                      0,
                      1
                    ],
                    "ix": 3
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 4
                  },
                  "w": {
                    "a": 0,
                    "k": 35,
                    "ix": 5
                  },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 0,
                    "k": [
                      519.971,
                      283.264
                    ],
                    "ix": 2
                  },
                  "a": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 1
                  },
                  "s": {
                    "a": 0,
                    "k": [
                      100,
                      100
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                  },
                  "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                  },
                  "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "nm": "Transform",
                  "_render": true
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          241.418,
                          37.416
                        ],
                        [
                          -220.754,
                          37.416
                        ],
                        [
                          -258.17,
                          20.664
                        ],
                        [
                          -258.17,
                          0
                        ],
                        [
                          -241.418,
                          -37.416
                        ],
                        [
                          220.754,
                          -37.416
                        ],
                        [
                          258.17,
                          -20.664
                        ],
                        [
                          258.17,
                          0
                        ]
                      ],
                      "o": [
                        [
                          220.754,
                          37.416
                        ],
                        [
                          -241.418,
                          37.416
                        ],
                        [
                          -258.17,
                          0
                        ],
                        [
                          -258.17,
                          -20.664
                        ],
                        [
                          -220.754,
                          -37.416
                        ],
                        [
                          241.418,
                          -37.416
                        ],
                        [
                          258.17,
                          0
                        ],
                        [
                          258.17,
                          20.664
                        ]
                      ],
                      "v": [
                        [
                          220.754,
                          37.416
                        ],
                        [
                          -220.754,
                          37.416
                        ],
                        [
                          -258.17,
                          0
                        ],
                        [
                          -258.17,
                          0
                        ],
                        [
                          -220.754,
                          -37.416
                        ],
                        [
                          220.754,
                          -37.416
                        ],
                        [
                          258.17,
                          0
                        ],
                        [
                          258.17,
                          0
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [
                      0,
                      0,
                      0,
                      1
                    ],
                    "ix": 3
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 4
                  },
                  "w": {
                    "a": 0,
                    "k": 35,
                    "ix": 5
                  },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 0,
                    "k": [
                      519.971,
                      348.118
                    ],
                    "ix": 2
                  },
                  "a": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 1
                  },
                  "s": {
                    "a": 0,
                    "k": [
                      100,
                      100
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                  },
                  "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                  },
                  "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "nm": "Transform",
                  "_render": true
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  519.971,
                  348.118
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  519.971,
                  348.118
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 0,
      "op": 120.12012012012,
      "st": 0,
      "ct": 1,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Group 1",
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 100,
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [
            375,
            439.854,
            0
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [
            519.971,
            556.061,
            0
          ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [
            100,
            100,
            100
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          -56.747
                        ],
                        [
                          0,
                          56.747
                        ]
                      ],
                      "o": [
                        [
                          0,
                          -56.747
                        ],
                        [
                          0,
                          56.747
                        ]
                      ],
                      "v": [
                        [
                          0,
                          -56.747
                        ],
                        [
                          0,
                          56.747
                        ]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [
                      0,
                      0,
                      0,
                      1
                    ],
                    "ix": 3
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 4
                  },
                  "w": {
                    "a": 0,
                    "k": 35,
                    "ix": 5
                  },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 0,
                    "k": [
                      609.769,
                      556.061
                    ],
                    "ix": 2
                  },
                  "a": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 1
                  },
                  "s": {
                    "a": 0,
                    "k": [
                      100,
                      100
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                  },
                  "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                  },
                  "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "nm": "Transform",
                  "_render": true
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          -56.747
                        ],
                        [
                          0,
                          56.747
                        ]
                      ],
                      "o": [
                        [
                          0,
                          -56.747
                        ],
                        [
                          0,
                          56.747
                        ]
                      ],
                      "v": [
                        [
                          0,
                          -56.747
                        ],
                        [
                          0,
                          56.747
                        ]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [
                      0,
                      0,
                      0,
                      1
                    ],
                    "ix": 3
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 4
                  },
                  "w": {
                    "a": 0,
                    "k": 35,
                    "ix": 5
                  },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 0,
                    "k": [
                      519.971,
                      556.061
                    ],
                    "ix": 2
                  },
                  "a": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 1
                  },
                  "s": {
                    "a": 0,
                    "k": [
                      100,
                      100
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                  },
                  "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                  },
                  "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "nm": "Transform",
                  "_render": true
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          -56.747
                        ],
                        [
                          0,
                          56.747
                        ]
                      ],
                      "o": [
                        [
                          0,
                          -56.747
                        ],
                        [
                          0,
                          56.747
                        ]
                      ],
                      "v": [
                        [
                          0,
                          -56.747
                        ],
                        [
                          0,
                          56.747
                        ]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [
                      0,
                      0,
                      0,
                      1
                    ],
                    "ix": 3
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 4
                  },
                  "w": {
                    "a": 0,
                    "k": 35,
                    "ix": 5
                  },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 0,
                    "k": [
                      430.172,
                      556.061
                    ],
                    "ix": 2
                  },
                  "a": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 1
                  },
                  "s": {
                    "a": 0,
                    "k": [
                      100,
                      100
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                  },
                  "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                  },
                  "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "nm": "Transform",
                  "_render": true
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  430.172,
                  556.061
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  430.172,
                  556.061
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 0,
      "op": 120.12012012012,
      "st": 0,
      "ct": 1,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Group 3",
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 100,
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [
            375,
            439.854,
            0
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [
            519.971,
            556.061,
            0
          ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [
            100,
            100,
            100
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [
                      210.256,
                      -170.527
                    ],
                    [
                      210.256,
                      53.176
                    ],
                    [
                      157.717,
                      170.527
                    ],
                    [
                      -92.906,
                      170.527
                    ],
                    [
                      -210.256,
                      117.98700000000001
                    ],
                    [
                      -210.256,
                      -170.527
                    ]
                  ],
                  "o": [
                    [
                      210.256,
                      -170.527
                    ],
                    [
                      210.256,
                      117.98700000000001
                    ],
                    [
                      92.906,
                      170.527
                    ],
                    [
                      -157.717,
                      170.527
                    ],
                    [
                      -210.256,
                      53.176
                    ],
                    [
                      -210.256,
                      -170.527
                    ]
                  ],
                  "v": [
                    [
                      210.256,
                      -170.527
                    ],
                    [
                      210.256,
                      53.176
                    ],
                    [
                      92.906,
                      170.527
                    ],
                    [
                      -92.906,
                      170.527
                    ],
                    [
                      -210.256,
                      53.176
                    ],
                    [
                      -210.256,
                      -170.527
                    ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0,
                  1
                ],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 35,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  519.971,
                  556.061
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 3",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 0,
      "op": 120.12012012012,
      "st": 0,
      "ct": 1,
      "bm": 0,
      "completed": true
    }
  ],
  "markers": [],
  "__complete": true
}